export const COUPON_TYPE = {
  Percentage: 'Percentage',
  Fixed: 'Fixed',
} as const

export const COUPON_DURATION = {
  Forever: 'forever',
  Once: 'once',
} as const
